/* eslint-disable */
import dayjs from "dayjs";
import _ from "lodash/fp";
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { Controller, useForm } from "react-hook-form";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import advertisementDetailsLabel from "../../application_management/labels/advertisement_details_en.json";
import ModuleHide from "../../common/components/ModuleHide";
import { BOOLEAN_OPTION, DEBARRED_NATURE } from "../../common/constants/dropdownOptions";
import commonENLabels from "../../common/labels/common_en.json";
import commonHILabels from "../../common/labels/common_hi.json";
import { getFormattedDate, preventDateManualTyping, toUTCDate } from "../../helpers/Datetime";
import commonLabels from "../../my_account/labels/common_en.json";
import "../../styles/advertisementTable.css";
import "../../styles/profile.css";
import { getFormattedLastUpdatedDate, getOtherInformation, otherInfoAction } from "../actions/profileAction";
import profile from "../labels/personal_information_en.json";
import numberformat from "../labels/serial_nos_en.json";
import { update } from "lodash";
import { disableAllSaveAfterSubmit} from "../actions/profileAction";

function OtherInformation(props) {
  const { register, handleSubmit, control, errors, watch, setValue } = useForm({
    mode: "onChange",
  });

  const { moduleList } = useSelector(
    (state) => state.loginReducer,
    shallowEqual
  );
  const [arraymModule, setarraymModule] = useState({});

  useEffect(() => {
    setarraymModule(
      moduleList &&
      moduleList.filter((ele) => ele.moduleName === "OTHER_INFO")[0]
    );
  }, [moduleList]);

  const [otherInfoBooleanState, setOtherInfoBooleanState] = useState({
    isProsecutionPending: "",
    isBarDisciplinaryActionInitiated: "",
    isGovDisciplinaryActionInitiated: "",
    isCourtCasePending: "",
    isDebarredForExamination: "",
    activities: "",
    distinctionLeadershipPosition: "",
    extraCurricular: "",
    updatedAt: "",
  });


  const [charCount, setCharCount] = useState({
    activities: 0,
    distinctionLeadershipPosition: 0,
    extraCurricular: 0,
  });

  const [limitReached, setLimitReached] = useState({
    activities: false,
    distinctionLeadershipPosition: false,
    extraCurricular: false,
  });



  let totalCharacters = 100;

  const handleOtherInfoBooleanState = (evt) => {

    const { name, value } = evt.target;

    setCharCount((prev) => ({
      ...prev,
      [name]: value.length,
    }));

    setLimitReached((prev) => ({
      ...prev,
      [name]: value.length > totalCharacters,
    }));

    setOtherInfoBooleanState({
      ...otherInfoBooleanState,
      [evt.target.name]: value,
    });
    if (evt.target.name === "isDebarredForExamination") {
      setOtherInfoBooleanState({
        ...otherInfoBooleanState,
        ["isDebarredForExamination"]: value,
      });
      setOtherInfoState({
        ...otherInfoState,
        ["nature"]: "",
        ["debarredStartDate"]: "",
        ["debarredEndDate"]: "",
      });
      setValue("nature", "");
      setValue("debarredStartDate", "");
      setValue("debarredEndDate", "");
    }
  };

  const [otherInfoState, setOtherInfoState] = useState({
    nature: "",
    debarredStartDate: "",
    debarredEndDate: "",
  });

  const handleOtherInfoState = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    if (name === "nature" && value === "2") {
      setOtherInfoState({
        ...otherInfoState,
        debarredStartDate: "",
        debarredEndDate: "",
        [event.target.name]: value,
      });
    } else {
      setOtherInfoState({
        ...otherInfoState,
        [event.target.name]: value,
      });
    }
  };

  let otherInformationResponse = useSelector(
    (state) => state.profile.otherInformationResponse
  );


  let authenticationDataObj = useSelector(
    (state) => state.profile.authenticationDataObj
  );
  const isDebarredForExaminationFlag = watch("isDebarredForExamination");
  const natureFlag = watch("nature");
  const debarredStartDate = watch("debarredStartDate");
  const debarredEndDate = watch("debarredEndDate");
  const isDisableAllTabSave = useSelector(
    (state) => state.profile.isDisableAllTabSave
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOtherInformation());
  }, []);


  useEffect(() => {
    setOtherInfoBooleanState({
      isProsecutionPending: otherInformationResponse.isProsecutionPending,
      isBarDisciplinaryActionInitiated:
        otherInformationResponse.isBarDisciplinaryActionInitiated,
      isGovDisciplinaryActionInitiated:
        otherInformationResponse.isGovDisciplinaryActionInitiated,
      isCourtCasePending: otherInformationResponse.isCourtCasePending,
      isDebarredForExamination:
        otherInformationResponse.isDebarredForExamination,
      activities: otherInformationResponse.activities,
      distinctionLeadershipPosition:
        otherInformationResponse.distinctionLeadershipPosition,
      extraCurricular: otherInformationResponse.extraCurricular,
      updatedAt: otherInformationResponse.updatedAt
    });
    setOtherInfoState({
      nature: otherInformationResponse.nature,
      debarredStartDate:
        otherInformationResponse.debarredStartDate &&
        dayjs(otherInformationResponse.debarredStartDate).toDate(),
      debarredEndDate:
        otherInformationResponse.debarredEndDate &&
        dayjs(otherInformationResponse.debarredEndDate).toDate(),
    });
    setValue(
      "debarredStartDate",
      otherInformationResponse.debarredStartDate &&
      dayjs(otherInformationResponse.debarredStartDate).toDate()
    );
    setValue(
      "debarredEndDate",
      otherInformationResponse.debarredEndDate &&
      dayjs(otherInformationResponse.debarredEndDate).toDate()
    );

  }, [otherInformationResponse]);


  
      useEffect(() => {
        if (!props.profileStatus) {
          dispatch(disableAllSaveAfterSubmit(false));
        } else if (
          props.enableEditProfileWithLock?.editProfileWithLock == "1"
        ) {
          dispatch(disableAllSaveAfterSubmit(false));
        } else {
          dispatch(disableAllSaveAfterSubmit(true));
        }
      }, [dispatch, props.profileStatus, props.enableEditProfileWithLock?.editProfileWithLock]);
      

  const formattedUpdatedDate = new Date(otherInfoBooleanState?.updatedAt)?.toLocaleDateString("en-GB");

  return arraymModule && arraymModule.isEnabled == false ? (
    <ModuleHide details={arraymModule} />
  ) : (
    <form
      className="form-group "
      onSubmit={handleSubmit((data) => {
        dispatch(otherInfoAction(data));
      })}
    >
      <div className=" p-4 f12">
        <div className="p-1 bg-blue date_flex">
          <h5 className="text-white">
            <img src="/icons/user-detail.png" /> &nbsp;
            {commonENLabels.OTHER_INFO.OTHER_INFO}{" "}
            {commonHILabels.OTHER_INFO.OTHER_INFO}
          </h5>
          <h5 className="text-white last_updated_date">
            {commonENLabels.LAST_UPDATED_ON}{" "}
            {getFormattedLastUpdatedDate(formattedUpdatedDate)}
          </h5>
        </div>
        <div className="p-1 mb-2 mt-3">
          <h5 className="bottom-dotted-line m-0">
            {numberformat["3.1"]}.&nbsp;{profile.OTHER_DETAILS_INFO_NOTE_1} :{" "}
            {commonHILabels.OTHER_INFO.NOTE_3_1}
          </h5>
        </div>
        <br />
        <div className="form-group row p-1">
          <div className="col-md-9">
            <label className="LeftText f11 font-weight">
              {numberformat["1"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_1_1}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.OTHER_INFO.NOTE_3_1_1}
            </label>
            <span className="errorText">*</span>
          </div>
          <div className="col-md-3 otherFormMarginBottom ">
            <select
              className="form-select bg-color"
              name="isProsecutionPending"
              value={otherInfoBooleanState.isProsecutionPending}
              ref={register({ required: true })}
              onInput={handleOtherInfoBooleanState}
            >
              <option key={0} value="">
                {advertisementDetailsLabel.SELECT}
              </option>
              {BOOLEAN_OPTION.map((ele, ind) => (
                <option key={ind++} value={ele.value}>
                  {ele.label}
                </option>
              ))}
            </select>
            {_.get("isProsecutionPending.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>
          <div className="col-md-9">
            <label className="LeftText f11 font-weight">
              {numberformat["2"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_1_2}
            </label>
            <label className="f11">
              {commonHILabels.OTHER_INFO.NOTE_3_1_2}
            </label>
            <span className="errorText">*</span>
          </div>
          <div className="col-md-3 otherFormMarginBottom">
            <select
              className="form-select bg-color"
              name="isBarDisciplinaryActionInitiated"
              value={otherInfoBooleanState.isBarDisciplinaryActionInitiated}
              ref={register({ required: true })}
              onInput={handleOtherInfoBooleanState}
            >
              <option key={0} value="">
                {advertisementDetailsLabel.SELECT}
              </option>
              {BOOLEAN_OPTION.map((ele, ind) => {
                return (
                  <option key={ind++} value={ele.value}>
                    {ele.label}
                  </option>
                );
              })}
            </select>
            {_.get("isBarDisciplinaryActionInitiated.type", errors) ===
              "required" && (
                <p className="errorText">
                  {" "}
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
          </div>

          <div className="col-md-9">
            <label className="LeftText f11 font-weight">
              {numberformat["3"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_1_3}
            </label>
            <label className="f11">
              {commonHILabels.OTHER_INFO.NOTE_3_1_3}
            </label>
            <span className="errorText">*</span>
          </div>
          <div className="col-md-3 otherFormMarginBottom">
            <select
              className="form-select bg-color"
              name="isGovDisciplinaryActionInitiated"
              value={otherInfoBooleanState.isGovDisciplinaryActionInitiated}
              ref={register({ required: true })}
              onInput={handleOtherInfoBooleanState}
            >
              <option key={0} value="">
                {advertisementDetailsLabel.SELECT}
              </option>
              {BOOLEAN_OPTION.map((ele, ind) => {
                return (
                  <option key={ind++} value={ele.value}>
                    {ele.label}
                  </option>
                );
              })}
            </select>
            {_.get("isGovDisciplinaryActionInitiated.type", errors) ===
              "required" && (
                <p className="errorText">
                  {" "}
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
          </div>

          <div className="col-md-9">
            <label className="LeftText f11 font-weight">
              {numberformat["4"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_1_4}
            </label>
            <label className="f11 margin-top-10">
              {commonHILabels.OTHER_INFO.NOTE_3_1_4}
            </label>
            <span className="errorText">*</span>
          </div>
          <div className="col-md-3 otherFormMarginBottom">
            <select
              className="form-select bg-color"
              name="isCourtCasePending"
              value={otherInfoBooleanState.isCourtCasePending}
              ref={register({ required: true })}
              onInput={handleOtherInfoBooleanState}
            >
              <option key={0} value="">
                {advertisementDetailsLabel.SELECT}
              </option>
              {BOOLEAN_OPTION.map((ele, ind) => {
                return (
                  <option key={ind++} value={ele.value}>
                    {ele.label}
                  </option>
                );
              })}
            </select>
            {_.get("isCourtCasePending.type", errors) === "required" && (
              <p className="errorText">
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>

          <div className="col-md-9">
            <label className="LeftText f11 font-weight">
              {numberformat["5"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_1_5}
            </label>
            <label className="f11 ">
              {commonHILabels.OTHER_INFO.NOTE_3_1_5}
            </label>
            <span className="errorText">*</span>
          </div>
          <div className="col-md-3 otherFormMarginBottom ">
            <select
              className="form-select bg-color"
              name="isDebarredForExamination"
              value={otherInfoBooleanState.isDebarredForExamination}
              ref={register({ required: true })}
              onInput={handleOtherInfoBooleanState}
            >
              <option key={0} value="">
                {advertisementDetailsLabel.SELECT}
              </option>
              {BOOLEAN_OPTION.map((ele, ind) => {
                return (
                  <option key={ind++} value={ele.value}>
                    {ele.label}
                  </option>
                );
              })}
            </select>
            {_.get("isDebarredForExamination.type", errors) === "required" && (
              <p className="errorText">
                {" "}
                {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
              </p>
            )}
          </div>

          {isDebarredForExaminationFlag &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-9">
              <label className="LeftText f11 font-weight">
                {numberformat["5.1"]}.&nbsp;
                {commonENLabels.OTHER_INFO.NOTE_3_1_6}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.OTHER_INFO.NOTE_3_1_6}
              </label>
              <span className="errorText">*</span>
            </div>
          ) : (
            ""
          )}
          {isDebarredForExaminationFlag &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-3">
              <select
                className="form-select bg-color"
                name="nature"
                value={otherInfoState.nature}
                ref={register({ required: true })}
                onInput={handleOtherInfoState}
              >
                <option key={0} value="">
                  {advertisementDetailsLabel.SELECT}
                </option>
                {DEBARRED_NATURE.map((ele, ind) => {
                  return (
                    <option key={ind++} value={ele.value}>
                      {ele.label}
                    </option>
                  );
                })}
              </select>
              {_.get("nature.type", errors) === "required" && (
                <p className="errorText">
                  {" "}
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            </div>
          ) : (
            ""
          )}
          {natureFlag &&
            natureFlag === "2" &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-9">
              <label className="LeftText f11 font-weight">
                {numberformat["5.1.1"]}.&nbsp;
                {commonENLabels.OTHER_INFO.NOTE_3_1_7}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.OTHER_INFO.NOTE_3_1_7}
              </label>
              <span className="errorText">*</span>
            </div>
          ) : (
            ""
          )}
          {natureFlag &&
            natureFlag === "2" &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-3 mt-2">
              {otherInformationResponse &&
                otherInformationResponse.otherInfoRowId ? (
                <Controller
                  name="debarredStartDate"
                  control={control}
                  key="fromDate1"
                  defaultValue={otherInfoState.debarredStartDate}
                  rules={{
                    required: true,
                  }}
                  render={({ onChange, value }) => (
                    <div className="date-picker-container">
                      <DatePicker
                        showIcon
                        maxDate={debarredEndDate || new Date()}
                        minDate={getFormattedDate(authenticationDataObj?.dob)}
                        selected={getFormattedDate(value)}
                        onChange={(e) => {
                          onChange(toUTCDate(e));
                        }}
                        onKeyDown={preventDateManualTyping}
                        placeholderText={commonLabels.DATE_FORMAT}
                        dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control bg-color ps-2"
                        icon={
                          <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                          ></img>
                        }
                      />
                    </div>
                  )}
                />
              ) : (
                <Controller
                  name="debarredStartDate"
                  control={control}
                  key="fromDate2"
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <div className="date-picker-container">
                      <DatePicker
                        showIcon
                        maxDate={debarredEndDate || new Date()}
                        selected={getFormattedDate(value)}
                        onChange={(e) => {
                          onChange(toUTCDate(e));
                        }}
                        onKeyDown={preventDateManualTyping}
                        placeholderText={commonLabels.DATE_FORMAT}
                        dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control bg-color ps-2"
                        icon={
                          <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                          ></img>
                        }
                      />
                    </div>
                  )}
                />
              )}
              {_.get("debarredStartDate.type", errors) === "required" && (
                <p className="errorText">
                  {" "}
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            </div>
          ) : (
            ""
          )}
          {natureFlag &&
            natureFlag === "2" &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-9">
              <label className="LeftText f11 font-weight">
                {numberformat["5.1.2"]}.&nbsp;
                {commonENLabels.OTHER_INFO.NOTE_3_1_8}
              </label>
              <label className="f11 margin-top-10">
                {commonHILabels.OTHER_INFO.NOTE_3_1_8}
              </label>
              <span className="errorText">*</span>
            </div>
          ) : (
            ""
          )}
          {natureFlag &&
            natureFlag === "2" &&
            isDebarredForExaminationFlag == "true" ? (
            <div className="col-md-3 mt-2">
              {otherInformationResponse &&
                otherInformationResponse.otherInfoRowId ? (
                <Controller
                  name="debarredEndDate"
                  control={control}
                  key="toDate1"
                  defaultValue={otherInfoState.debarredEndDate}
                  rules={{
                    required: true,
                  }}
                  render={({ onChange, value }) => (
                    <div className="date-picker-container">
                      <DatePicker
                        showIcon
                        minDate={debarredStartDate}
                        selected={getFormattedDate(value)}
                        onChange={(e) => {
                          onChange(toUTCDate(e));
                        }}
                        onKeyDown={preventDateManualTyping}
                        placeholderText={commonLabels.DATE_FORMAT}
                        dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control bg-color ps-2"
                        icon={
                          <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                          ></img>
                        }
                      />
                    </div>
                  )}
                />
              ) : (
                <Controller
                  name="debarredEndDate"
                  control={control}
                  key="toDate2"
                  rules={{ required: true }}
                  render={({ onChange, value }) => (
                    <div className="date-picker-container">
                      <DatePicker
                        showIcon
                        minDate={debarredStartDate}
                        selected={getFormattedDate(value)}
                        onChange={(e) => {
                          onChange(toUTCDate(e));
                        }}
                        onKeyDown={preventDateManualTyping}
                        placeholderText={commonLabels.DATE_FORMAT}
                        dateFormat={commonLabels.SMALL_SIZE_DATE_FORMAT}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        className="form-control bg-color ps-2"
                        icon={
                          <img
                            src="/icons/calender.png"
                            className="date-picker-icon"
                          ></img>
                        }
                      />
                    </div>
                  )}
                />
              )}
              {_.get("debarredEndDate.type", errors) === "required" && (
                <p className="errorText">
                  {" "}
                  {commonENLabels.VALIDATE_MESSAGE.FIELD_REQ}
                </p>
              )}
            </div>
          ) : (
            ""
          )}
        </div>
        <hr></hr>
      </div>

      <div className="p-4 f12">
        <div className="p-1">
          <h5 className="bottom-dotted-line m-0">
            {numberformat["3.2"]}.&nbsp;{profile.OTHER_DETAILS_INFO_NOTE_2} :{" "}
            {commonHILabels.OTHER_INFO.NOTE_3_2}
          </h5>
        </div>
        <br />
        <div className="form-group row p-1">
          <div className="col-md-8">
            <label className="LeftText f11 font-weight">
              {numberformat["1"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_2_1}
            </label>
            <label className="f11 margin-top-10">
              &nbsp;&nbsp;{commonHILabels.OTHER_INFO.NOTE_3_2_1}
            </label>
          </div>
          <div className="col-md-4 mb-3">
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control text-uppercase"
                onInput={handleOtherInfoBooleanState}
                defaultValue={otherInfoBooleanState.activities}
                name="activities"
                ref={register({ required: false })}
                autoComplete="off"
                maxLength={100}
              />
            </div>
            <p className="desc_words" >
              <span className="successText">Characters: {charCount.activities}/{totalCharacters}</span>
              {limitReached.activities && (
                <span className="errorText">
                  You have reached the limit!
                </span>
              )}
            </p>
          </div>

          <div className="col-md-8">
            <label className="LeftText f11 font-weight">
              {numberformat["2"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_2_2}
            </label>
            <label className="f11 margin-top-10">
              &nbsp;&nbsp;{commonHILabels.OTHER_INFO.NOTE_3_2_2}
            </label>
          </div>
          <div className="col-md-4 mb-3">
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control text-uppercase"
                onInput={handleOtherInfoBooleanState}
                defaultValue={
                  otherInfoBooleanState.distinctionLeadershipPosition
                }
                name="distinctionLeadershipPosition"
                ref={register({ required: false })}
                autoComplete="off"
                maxLength={100}
              />
            </div>
            <p className="desc_words" >
              <span className="successText">Characters: {charCount.distinctionLeadershipPosition}/{totalCharacters}</span>
              {limitReached.distinctionLeadershipPosition && (
                <span className="errorText">
                  You have reached the limit!
                </span>
              )}
            </p>
          </div>

          <div className="col-md-8">
            <label className="LeftText f11 font-weight">
              {numberformat["3"]}.&nbsp;{commonENLabels.OTHER_INFO.NOTE_3_2_3}
            </label>
            <label className="f11 margin-top-10">
              &nbsp;&nbsp;{commonHILabels.OTHER_INFO.NOTE_3_2_3}
            </label>
          </div>
          <div className="col-md-4 mb-3">
            <div className="input-group bg-color">
              <input
                type="text"
                className="form-control text-uppercase"
                onInput={handleOtherInfoBooleanState}
                defaultValue={otherInfoBooleanState.extraCurricular}
                name="extraCurricular"
                ref={register({ required: false })}
                autoComplete="off"
                maxLength={100}
              />
            </div>
            <p className="desc_words" >
              <span className="successText">Characters: {charCount.extraCurricular}/{totalCharacters}</span>
              {limitReached.extraCurricular && (
                <span className="errorText">
                  You have reached the limit!
                </span>
              )}
            </p>
          </div>
        </div>
        <div className="text-center">
          <hr></hr>

          {
            props.profileStatus !== true ? (
              <button
                type="submit"
                className=" btn btn-primary custom_button "
                disabled={isDisableAllTabSave}
              >
                 {profile.SAVE}
              </button>
            ) : (
              <div className="text-center">
                {(() => {
                  const OtherInfoList = props.enableEditProfileWithLock?.OtherInfo?.split(",") || [];
                  const canUpdate = OtherInfoList.includes("U");
                   const canCreate = OtherInfoList.includes("C");
                  const isReadOnly = OtherInfoList.includes("R");

                  if (props.enableEditProfileWithLock?.editProfileWithLock == "1") {
                    if (canUpdate || canCreate) {
                      return (
                        <button
                          type="submit"
                          className=" btn btn-primary custom_button "
                          disabled={isDisableAllTabSave}
                        >
                          {profile.SAVE}
                        </button>
                      );
                    } else if (isReadOnly) {
                      return (
                        <span className="profile_disable_button">
                          {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
                        </span>
                      );
                    }
                  }
                  return null;
                })()}
              </div>
            )
          }



          {/* {
            otherInformationResponse.isLocked !== true ? (
              <button
                type="submit"
                className=" btn btn-primary custom_button "
                disabled={isDisableAllTabSave}
              >
                {profile.SAVE}
              </button>
            ) : (
              <span className="profile_disable_button">
                {commonENLabels.PERSONAL_INFORMATION.DISABLE_BUTTON_TEXT}
              </span>
            )}  */}
        </div>
      </div>
    </form>
  );
}

export default OtherInformation;
